import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { NgxCurrencyConfig, NgxCurrencyDirective } from 'ngx-currency';

import { AbntPipe } from '../../../../../../../../shared/pipes/abnt.pipe';
import { baseDaComissao } from '../../../venda-item.calculo';

/**
 * Aba "Comissão" do item (§6.4), só no pedido de venda, igual à do item da NF-e de saída.
 *
 * A base é o valor negociado do item menos a parcela rateada do desconto do documento: comissão
 * sobre o que o cliente paga. O valor é o que `recalcularValoresDoItem` apura com a mesma base.
 */
@Component({
    selector: 'app-vd-item-aba-comissao',
    standalone: true,
    imports: [AbntPipe, ReactiveFormsModule, MatFormFieldModule, MatInputModule, NgxCurrencyDirective],
    templateUrl: './vd-item-aba-comissao.component.html',
    styleUrls: ['../abas-comum.css', './vd-item-aba-comissao.component.css'],
})
export class VdItemAbaComissaoComponent {
    @Input({ required: true }) public item!: FormGroup;
    @Input({ required: true }) public mascaraPercentual!: Partial<NgxCurrencyConfig>;

    public get comissao(): FormGroup {
        return this.item.get('comissao') as FormGroup;
    }

    public get base(): number {
        return baseDaComissao(this.item);
    }

    public get valor(): number {
        return Number(this.comissao.get('valorComissao')?.value ?? 0) || 0;
    }
}
